import React from 'react';
import LoadingSVG from './res/loading-pulse.svg';
const LoadingImg = () => {
  return <img src={LoadingSVG} alt='loading...' />;
};
export default LoadingImg;
